/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./configuration.component.scss.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./configuration.component";
import * as i3 from "@angular/common";
var styles_ConfigurationComponent = [i0.styles];
var RenderType_ConfigurationComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_ConfigurationComponent, data: {} });
export { RenderType_ConfigurationComponent as RenderType_ConfigurationComponent };
export function View_ConfigurationComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_ConfigurationComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-configuration", [], null, null, null, View_ConfigurationComponent_0, RenderType_ConfigurationComponent)), i1.ɵdid(1, 114688, null, 0, i2.ConfigurationComponent, [i1.NgZone, i3.Location], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ConfigurationComponentNgFactory = i1.ɵccf("app-configuration", i2.ConfigurationComponent, View_ConfigurationComponent_Host_0, {}, {}, []);
export { ConfigurationComponentNgFactory as ConfigurationComponentNgFactory };
